import React, { useContext, useState } from 'react';

import MuiMenu from '@material-ui/core/Menu/Menu';
import IconButton from '@material-ui/core/IconButton';

import { useNotifications } from './notifications-hook';
import { NotificationsIcon } from './notifications-icon';
import { useNotificationsStyles } from './notifications-styles';
import { NotificationsList } from './notifications-list';
import { AuthCtx } from 'components/auth/auth-ctx';

export const Notifications = () => {
  const classes = useNotificationsStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { userInfo } = useContext(AuthCtx);
  const {
    count,
    notifications,
    readNotifications,
    readAllNotifications,
  } = useNotifications();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return userInfo?.id ? (
    <>
      <IconButton
        aria-controls="notificiations-btn"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <NotificationsIcon count={count} />
      </IconButton>
      <MuiMenu
        id="notificiations-menu"
        anchorEl={anchorEl}
        keepMounted
        open={!!anchorEl}
        onClose={handleClose}
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        classes={{ paper: classes.menu }}
      >
        <NotificationsList
          count={count}
          notifications={notifications}
          readNotifications={readNotifications}
          readAll={readAllNotifications}
          handleClose={handleClose}
        />
      </MuiMenu>
    </>
  ) : (
    <></>
  );
};
